// By response count, then alphabetically
export const sortDescriptors = (a, b) => {
    if (a.responseCount < b.responseCount) return 1;
    if (a.responseCount > b.responseCount) return -1;
    if (a.descriptor < b.descriptor) return -1;
    if (a.descriptor > b.descriptor) return 1;
    return 0;
};
